// Generated by purs version 0.11.7
"use strict";
var $foreign = require("./foreign");
var crash = function (dictPartial) {
    return $foreign.crashWith(dictPartial)("Partial.crash: partial function");
};
module.exports = {
    crash: crash,
    crashWith: $foreign.crashWith
};



//////////////////
// WEBPACK FOOTER
// ./output/Partial/index.js
// module id = 307
// module chunks = 0